import { JSX } from "react"

import Sprite from "../../Component/Sprite"
import FighterInterface from "../../Model/FighterInterface"

import ValueView from "./ValueView"

type Props = {
  onClick?: () => void
  fighter: FighterInterface
  displayValue: boolean
}

const spriteMap: Record<"enemy" | "me", "orc" | "soldier"> = {
  enemy: "orc",
  me: "soldier",
}

export default function FighterView({
  onClick,
  fighter,
  displayValue,
}: Props): JSX.Element {
  return (
    <div
      className={`fighter ${fighter.type} ${fighter.position} ${fighter.status === "fighting" ? "fighting" : ""}`}
      onClick={onClick}
    >
      <ValueView value={fighter.value} displayValue={displayValue} />
      <Sprite type={spriteMap[fighter.type]} sprite={fighter.status} />
    </div>
  )
}
